import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';

export default function HowWeWorkSection() {
  const { t } = useLanguage();
  const paragraphs = t('howWeWork.paragraphs');
  return (
    <section id="howwework" data-testid="howwework-section" className="bg-[#f5f5f5] py-24 md:py-32">
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: '-100px' }} transition={{ duration: 0.7 }}
          data-testid="howwework-title" className="text-[#1f1f1f] text-3xl md:text-4xl font-bold uppercase tracking-tight leading-[1.3] mb-10" style={{ fontFamily: "'Oswald', sans-serif" }}>
          {t('howWeWork.title')}
        </motion.h2>
        {Array.isArray(paragraphs) && paragraphs.map((p, i) => (
          <motion.p key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.1 }}
            className="text-[#1f1f1f]/70 text-base md:text-lg leading-relaxed mb-6" style={{ fontFamily: "'Manrope', sans-serif" }}>
            {p}
          </motion.p>
        ))}
      </div>
    </section>
  );
}
